import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import { colors, Button, Grid, Card, CardContent, CardHeader, Divider } from '@mui/material';
import { Page, Header, Alert, FilePicker, FilesDropzoneMix } from 'components';
import { enqueueSnackbar } from 'actions';
import ModalDialog from '../../../../../../../../components/ModalDialog/ModalDialog.js';
import { SetFormState, UploadAttachments, ToggleAttachFileSiteTrackerDialog } from '../../../../../../actions/SiteTrackerActions.js';

const useStyles = makeStyles((theme) => ({
	root: {
		width: 960,
	},
	header: {
		padding: theme.spacing(3),
		maxWidth: 720,
		margin: '0 auto',
	},
	content: {
		padding: theme.spacing(0, 2),
		maxWidth: 720,
		margin: '0 auto',
	},
	helperText: {
		textAlign: 'right',
		marginRight: 0,
	},
	author: {
		margin: theme.spacing(4, 0),
		display: 'flex',
	},
	avatar: {
		marginRight: theme.spacing(2),
	},
	actions: {
		backgroundColor: colors.grey[100],
		padding: theme.spacing(2),
		display: 'flex',
		alignContent: 'right',
	},
	applyButton: {
		color: theme.palette.white,
		backgroundColor: colors.green[600],
		'&:hover': {
			backgroundColor: colors.green[900],
		},
	},
}));

const TeamsAddFilesDialog = (props) => {
	const { author, open, onClose, onApply, className, tableId, title, ...rest } = props;
	const classes = useStyles();
	const dispatch = useDispatch();
	const setFormState = formState => dispatch(SetFormState(formState));
	const formState = useSelector((state) => state.siteTrackerReducer.formState);
	const userId = useSelector(state => state.session.user.id);

	const _addAttachments = (files, image) => {
		files.forEach(file => {
			if (!file.size > 50000000) {
				dispatch(enqueueSnackbar({ message: `File size${file.name} cannot be superior to 50MB`, options: { variant: 'warning' } }));
			}
		});
		dispatch(UploadAttachments(userId, tableId, title, files, image));
		dispatch(ToggleAttachFileSiteTrackerDialog(false));
		dispatch(enqueueSnackbar({ message: 'Files uploaded', options: { variant: 'info' } }));
	};

	return (
		<ModalDialog
			// maxWidth="xs"
			onClose={onClose}
			open={open}
			title="Add Attachment Files"
			// confirmLabel="Ok"
			hasConfirm={false}
		// onConfirmClicked={_onConfirmClick}
		>
			<div className={classes.fields}>
				<Card className={classes.container} container spacing={3}>
					{/* <CardHeader title="Upload" /> */}
					<Divider />
					<CardContent>
						<FilesDropzoneMix
							// acceptedTypes=".jpg"
							upload={_addAttachments}
							title={title}
						/>
					</CardContent>
				</Card>
			</div>

		</ModalDialog>
	);
};

TeamsAddFilesDialog.propTypes = {
	author: PropTypes.object,
	className: PropTypes.string,
	onApply: PropTypes.func,
	onClose: PropTypes.func,
	open: PropTypes.bool,
	tableId: PropTypes.any,
	title: PropTypes.string
};

export default TeamsAddFilesDialog;
